//config
import DiccionarioEtiquetas from '../Configuracion/Idiomas/Etiquetas_Diccionario';

//context app
import { useStateValue } from '../Contexto/store';

/**
 * 
 * @returns {{ compania:{CfgNavBarColor:string, CfgNavTextColor:string}, sesionUsuario:{  usuario:{companyId:string, customerId:string}},
 *  etiquetas: { Cuaderno:{Et_lblDetalles:string}, General:{ Et_tblAcciones:string, Et_Regresar:string, Et_tbnGuardar:string, Et_tbnAceptar:string, Et_tbnCancelar:string, Et_tblItems:string },
 *  Home:{ Et_lblRegistro:string, Et_lblHabilitadoModulo:string}, Mensajeria:{Et_LblBuzonSalidaTablet:string, Et_LblBuzonEntradaTablet:string, Et_Descripcion:string, Et_LblBuzonEntrada:strng} }, 
 *  codigoIdioma:string, dispatch: () => void }}
 */
export const useGlobalState = () => {

   // se accede a la variable de sesion de usuario del storage para luego saber si el usuario esta logueado 
   const [{ sesionUsuario, autorizacion, etiquetasIdioma, openSnackbar, compania }, dispatch] = useStateValue();
    
   const etiquetas = etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas;
   const codigoIdioma = etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma;
 
   return { etiquetas,  codigoIdioma, sesionUsuario, autorizacion, openSnackbar, compania, dispatch}

}